// extracted by mini-css-extract-plugin
module.exports = {"windowBox":"style_windowBox__2Un_P","slides":"style_slides__1QSHH","arrow":"style_arrow__1IPlh","left":"style_left__3mIYq","right":"style_right__2N5i_"};